import Vue from "vue";
import VueRouter from "vue-router";

const Home = () => import("@/pages/Home/Home");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkExactActiveClass: "is-active",
  scrollBehavior: (to, from) => {
    if (!to.hash) {
      return scroll({
        top: 0,
        behavior: "smooth"
      });
    }

    if (to.hash === from.hash) {
      setTimeout(() => {
        return scroll({
          top: document.querySelector(to.hash).offsetTop,
          behavior: "smooth"
        });
      }, 300);

      return;
    }

    return scroll({
      top: document.querySelector(to.hash).offsetTop,
      behavior: "smooth"
    });
  },
  routes
});

export default router;
